export const GROUP_NAME_MAX_LENGTH = 800;

const SITE_NAME_REGEX = /^[0-9a-zA-Z_.,@/:#-]+$/;
const NO_SPACE_REGEX = /^\S*$/;

export type GatewayValidationMessages = {
    siteNameRequired: string;
    siteNameTooLong: string;
    siteNameSpaceNotAllowed: string;
    siteNameInvalidFormat: string;
    regionRequired: string;
};

export const validateGatewayForm = (
    site: string,
    region: string,
    messages: GatewayValidationMessages
): string => {
    const trimmedSite = site.trim();

    if (!trimmedSite) {
        return messages.siteNameRequired;
    }

    if (trimmedSite.length > GROUP_NAME_MAX_LENGTH) {
        return messages.siteNameTooLong;
    }

    if (!NO_SPACE_REGEX.test(trimmedSite)) {
        return messages.siteNameSpaceNotAllowed;
    }

    if (!SITE_NAME_REGEX.test(trimmedSite)) {
        return messages.siteNameInvalidFormat;
    }

    if (!region.trim()) {
        return messages.regionRequired;
    }

    return "";
};
